import * as _ from 'lodash'
import util from './util';
import serviceGateway from './serviceGateway';
import store, { getCollection, ModelCollection } from './store';
import * as globalActions from './actions';
import vendorModel from './models/vendorModel';
import enums from './enum';
import socketClient from './socketClient';

function processVendorResult (vendors) {
	const collection = getCollection({ collection: ModelCollection.vendors });

	collection.withMutations(c => {
		_.forEach(vendors, item => {
			c.set(item.key, vendorModel(item));
		});
	});
}

export const socketClientHandlers = {
	['model.vendor.added']: message => {
		fetchVendor({ key: message.payload.key });
	},
	['model.vendor.updated']: message => {
		const keyPath = ['model', 'vendors', message.payload.key];
		const existing = store().getIn(keyPath);

		if (existing) {
			if (existing.itemVersion === message.payload.patchTargetVersion) {
				existing.applyPatch(message.payload.patch);
				store().setIn(keyPath, existing);
			}
			else if (existing.itemVersion < message.payload.patchTargetVersion) {
				fetchVendor({ key: message.payload.key });
			}
		}
		else {
			fetchVendor({ key: message.payload.key });
		}
	}
};

// wrap handlers to allow extensions to override
for (const key of _.keys(socketClientHandlers)) {
	socketClient.on(key, message => {
		socketClientHandlers[key](message);
	});
}

// NOTE: Action returns are only to allow tests to access the promise. DO NOT use return values in runtime code.
export const fetchVendor = params => {
	return serviceGateway.fetchVendor(params)
		.then(result => {
			processVendorResult([result.vendor]);
		})
		.catch(err => {
			globalActions.pushAlert({ type: 'warning', message: err.message || err, isCloseable: true });
		});
};

export const fetchVendors = params => {
	return serviceGateway.searchVendors({ vendor: { type: params.type }})
		.then(result => {
			processVendorResult(result.vendors);
		})
		.catch(err => {
			globalActions.pushAlert({ type: 'warning', message: err.message || err, isCloseable: true });
		});
};

export const fetchCabinetSuppliers = () => {
	return fetchVendors({ type: enums.vendorTypes.Cabinet_Supplier });
};

export const fetchCounterSuppliers = () => {
	return fetchVendors({ type: enums.vendorTypes.Counter_Supplier });
};

export const fetchOutsideSuppliers = () => {
	return fetchVendors({ type: enums.vendorTypes.Outside_Supplier });
};

export const fetchWarehouse = () => {
	return fetchVendors({ type: enums.vendorTypes.Internal_Warehouse });
};

export const searchVendors = params => {
	return serviceGateway.searchVendors(params)
		.then(result => {
			return _.map(result.vendors, c => {
				return vendorModel(c);
			});
		})
		.catch(err => {
			globalActions.pushAlert({ type: 'warning', message: err.message || err, isCloseable: true });
		});
};

export const saveVendor = params => {
	const keyPath = ['model', 'vendors', params.vendor.key];

	store().setIn(keyPath, vendorModel(params.vendor));

	return serviceGateway.saveVendor({ vendor: params.vendor, patch: params.vendor.dateCreated ? params.patch : undefined })
		.then(result => {
			processVendorResult([result.vendor]);
		})
		.catch(err => {
			const key = util.generateGuid();
			const retry = p => {
				globalActions.clearAlert({ key: key });
				return saveVendor(p || params);
			};

			globalActions.pushAlert({
				key: key,
				type: 'error',
				message: err.message || 'Server Error',
				source: 'server',
				action: 'saveVendor',
				retry: retry,
				params: params,
				orgininalError: err,
				isCloseable: true
			});
		});
};